import { Box, Skeleton, Typography } from "@mui/material";
import React from "react";

import FactoryIcon from "@mui/icons-material/Factory";
import PlantModuleNav from "./PlantModuleNav";
import useStandaloneView from "../hooks/useStandaloneView";

export default function PageHeader({ plant, pageTitle }) {
  const standalone = useStandaloneView();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        justifyContent: "space-between",
        px: 2,
        pt: 1,
        pb: 0,
      }}
    >
      <Typography
        variant="h6"
        fontWeight={700}
        sx={{
          color: "text.main",
          bgcolor: (theme) => `${theme.palette.primary.main}14`,
          px: 1.5,
          py: 0.5,
          borderRadius: 1,
          borderLeft: "4px solid",
          borderColor: "primary.main",
        }}
      >
        {pageTitle}
      </Typography>

      <Box
        sx={{
          px: 2,
          py: 1,
          borderRadius: 2,
          bgcolor: "action.hover",
          display: "flex",
          alignItems: "center",
          gap: 1,
          minWidth: 180,
          justifyContent: "center",
        }}
      >
        <FactoryIcon fontSize="small" color="primary" />
        <Box>
          <Box
            sx={{
              fontSize: "0.7rem",
              color: "text.secondary",
              lineHeight: 1,
            }}
          >
            Plant
          </Box>
          {plant?.name ? (
            <Box sx={{ fontWeight: 700, fontSize: "0.95rem" }}>
              {plant?.name || "-"}
            </Box>
          ) : (
            <Box mt={0.5}>
              <Skeleton variant="rectangular" width={160} height={22} />
            </Box>
          )}
        </Box>
        {!standalone && <PlantModuleNav plantId={plant.id} compact />}
      </Box>
    </Box>
  );
}
